import RenderFormField from '@/components/form-tabs/fields'
import { FormState } from '@/state'
import { Form } from 'antd'

import React from 'react'
import SectionFormTableHeader from './header'

import './styles.scss'
import { EFormTableMode } from '@/interfaces'

export default function SubsectionTableForm() {
  const [subsectionForm] = Form.useForm()

  React.useEffect(() => {
    subsectionForm.resetFields()
    subsectionForm.setFieldsValue(FormState.entityForm.value.values)

    return subsectionForm.resetFields
  }, [FormState.entityForm.value])

  return (
    <div className='table-entity-form'>
      <SectionFormTableHeader form={subsectionForm} showTitle />

      <Form
        className='subsection-form'
        initialValues={FormState.entityForm.value.values}
        form={subsectionForm}
        layout='vertical'
        disabled={FormState.entityForm.value.mode === EFormTableMode.VIEW}
      >
        {FormState.entityForm.value.form?.map((fieldInfo, idx) => (
          <RenderFormField
            key={fieldInfo.name}
            fieldInfo={fieldInfo}
            index={idx + 1}
          />
        ))}
      </Form>

      <SectionFormTableHeader form={subsectionForm} />
    </div>
  )
}
